import { buildAccommodationCancellationPolicies } from '@luxuryescapes/lib-refunds'

interface Input {
  fullyRefundableUntil: App.BasePropertyRate['fullyRefundableUntil']
  cancellationPolicies: App.BasePropertyRate['cancellationPolicies']
  propertyTimeZone: string
  currency: App.BasePropertyRate['currency']
  shouldClarifyRefundIsHotelOnly: boolean
  locale: string
}

export function getPropertyCancellationPolicyDescriptions({ fullyRefundableUntil, cancellationPolicies, propertyTimeZone, currency, shouldClarifyRefundIsHotelOnly, locale }: Input) {
  return buildAccommodationCancellationPolicies({
    fullRefundableUntil: fullyRefundableUntil,
    cancellationPolicies: cancellationPolicies.map(({
      startIsoDateTime,
      endIsoDateTime,
      penaltyPrice,
      isFullyNonRefundable,
      originalDescription,
    }) => ({
      // TODO(HP-1333): Update `lib-refunds` to conform to Customer Portal interface.
      amount: penaltyPrice,
      percent: 0,
      description: originalDescription,
      start: startIsoDateTime,
      end: endIsoDateTime,
      nonRefundable: isFullyNonRefundable,
    })),
  }, {
    timezone: propertyTimeZone,
    currencyCode: currency,
    hideExcludesFlights: !shouldClarifyRefundIsHotelOnly,
    locale,
  }).description
}
